import { render } from "./NeeraAnchor.vue?vue&type=template&id=4dd72f85&scoped=true"
import script from "./NeeraAnchor.vue?vue&type=script&lang=js"
export * from "./NeeraAnchor.vue?vue&type=script&lang=js"

import "./NeeraAnchor.vue?vue&type=style&index=0&id=4dd72f85&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd72f85"]])

export default __exports__